import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { searchSectionSearchValue as searchSectionSearchValueSelector } from '@Pages/QueryBuilder/QuerySelector';
import { setSearchSectionSearchValue as setSearchSectionSearchValueAction } from '@Pages/QueryBuilder/QueryletActions';
import SearchInput from './SearchInput';
import useSearchQuerylets from './SearchInput/useSearchQuerylets';
import SectionsTabs from './SectionsTabs';
import SearchedQuerylets from './SectionsTabs/SearchedQuerylets';
import * as searchSectionHelpers from './SearchSectionHelper';

import './SearchSection.scss';

function SearchSection({ properties, forms, getForms, historyItems, indexedQuerylets, indexedForms, getHistoryItems, addToBuilder }) {
  const dispatch = useDispatch();
  // Search value from Redux
  const searchValue = useSelector(searchSectionSearchValueSelector);
  const setSearchValue = (_searchValue) => {
    dispatch(setSearchSectionSearchValueAction(_searchValue));
  };

  const [isSearched, searchedQuerylets] = useSearchQuerylets(searchValue, indexedQuerylets, indexedForms);
  const collectedFields = useMemo(() => searchSectionHelpers.nodesCollector(properties), [properties]);
  const collectedForms = useMemo(() => searchSectionHelpers.nodesCollector(forms), [forms]);
  const collectedHistoryItems = useMemo(() => searchSectionHelpers.nodesCollector(historyItems), [historyItems]);
  const collectedSearchedQuerylets = useMemo(() => searchSectionHelpers.nodesCollector(searchedQuerylets), [searchedQuerylets]);

  return (
    <div id="advancedSearchPage" className="advanced-search--container query-builder-search-section">
      <SearchInput value={searchValue} onChange={setSearchValue} />
      {isSearched ? (
        <SearchedQuerylets nodes={collectedSearchedQuerylets} addToBuilder={addToBuilder} />
      ) : (
        <SectionsTabs
          collectedFields={collectedFields}
          collectedForms={collectedForms}
          collectedHistoryItems={collectedHistoryItems}
          getForms={getForms}
          getHistoryItems={getHistoryItems}
          addToBuilder={addToBuilder}
        />
      )}
    </div>
  );
}

SearchSection.propTypes = {
  properties: PropTypes.array.isRequired,
  forms: PropTypes.array.isRequired,
  getForms: PropTypes.func.isRequired,
  historyItems: PropTypes.array.isRequired,
  getHistoryItems: PropTypes.func.isRequired,
  indexedQuerylets: PropTypes.object,
  indexedForms: PropTypes.object,
  addToBuilder: PropTypes.func,
};

export default SearchSection;
